/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PartnerContentDto } from '../model/partnerContentDto';
import { Relay } from '../model/relay';
import { RelayCredentialDto } from '../model/relayCredentialDto';
import { RelayDto } from '../model/relayDto';
import { RelaySchemaDto } from '../model/relaySchemaDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RelayService {

    protected basePath = 'http://10.1.1.123:30118';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param relay 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public relayCreate(relay: PartnerContentDto, observe?: 'body', reportProgress?: boolean): Observable<Relay>;
    public relayCreate(relay: PartnerContentDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Relay>>;
    public relayCreate(relay: PartnerContentDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Relay>>;
    public relayCreate(relay: PartnerContentDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (relay === null || relay === undefined) {
            throw new Error('Required parameter relay was null or undefined when calling relayCreate.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Relay>(`${this.basePath}/api/Relay/Create`,
            relay,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public relayDelete(model: Relay, observe?: 'body', reportProgress?: boolean): Observable<Relay>;
    public relayDelete(model: Relay, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Relay>>;
    public relayDelete(model: Relay, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Relay>>;
    public relayDelete(model: Relay, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling relayDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<Relay>(`${this.basePath}/api/Relay/Delete`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param partnerId 
     * @param partnerGuidId 
     * @param keyword 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public relayGetAll(partnerId?: number, partnerGuidId?: string, keyword?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<RelayDto>;
    public relayGetAll(partnerId?: number, partnerGuidId?: string, keyword?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RelayDto>>;
    public relayGetAll(partnerId?: number, partnerGuidId?: string, keyword?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RelayDto>>;
    public relayGetAll(partnerId?: number, partnerGuidId?: string, keyword?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (partnerId !== undefined && partnerId !== null) {
            queryParameters = queryParameters.set('partnerId', <any>partnerId);
        }
        if (partnerGuidId !== undefined && partnerGuidId !== null) {
            queryParameters = queryParameters.set('partnerGuidId', <any>partnerGuidId);
        }
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('keyword', <any>keyword);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RelayDto>(`${this.basePath}/api/Relay/GetAll`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param partnerId 
     * @param partnerContentId 
     * @param creatorId 
     * @param keyword 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public relayGetAllByPartnerId(partnerId?: number, partnerContentId?: number, creatorId?: string, keyword?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<RelayCredentialDto>;
    public relayGetAllByPartnerId(partnerId?: number, partnerContentId?: number, creatorId?: string, keyword?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RelayCredentialDto>>;
    public relayGetAllByPartnerId(partnerId?: number, partnerContentId?: number, creatorId?: string, keyword?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RelayCredentialDto>>;
    public relayGetAllByPartnerId(partnerId?: number, partnerContentId?: number, creatorId?: string, keyword?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (partnerId !== undefined && partnerId !== null) {
            queryParameters = queryParameters.set('partnerId', <any>partnerId);
        }
        if (partnerContentId !== undefined && partnerContentId !== null) {
            queryParameters = queryParameters.set('partnerContentId', <any>partnerContentId);
        }
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (keyword !== undefined && keyword !== null) {
            queryParameters = queryParameters.set('keyword', <any>keyword);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RelayCredentialDto>(`${this.basePath}/api/Relay/GetAllByPartnerId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param partnerContentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public relayGetRelayByPartnerContentId(partnerContentId?: number, observe?: 'body', reportProgress?: boolean): Observable<RelaySchemaDto>;
    public relayGetRelayByPartnerContentId(partnerContentId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RelaySchemaDto>>;
    public relayGetRelayByPartnerContentId(partnerContentId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RelaySchemaDto>>;
    public relayGetRelayByPartnerContentId(partnerContentId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (partnerContentId !== undefined && partnerContentId !== null) {
            queryParameters = queryParameters.set('partnerContentId', <any>partnerContentId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<RelaySchemaDto>(`${this.basePath}/api/Relay/GetRelayByPartnerContentId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public relayUpdate(model: Relay, observe?: 'body', reportProgress?: boolean): Observable<Relay>;
    public relayUpdate(model: Relay, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Relay>>;
    public relayUpdate(model: Relay, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Relay>>;
    public relayUpdate(model: Relay, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling relayUpdate.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Relay>(`${this.basePath}/api/Relay/Update`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
